:root {
  color: #18201d;
  background: #eef2ed;
  font-family: Inter, ui-sans-serif, system-ui, sans-serif;
  font-synthesis: none;
}

body {
  margin: 0;
  min-width: 320px;
}

main {
  width: min(760px, calc(100% - 40px));
  margin: 0 auto;
  padding: 72px 0;
}

.eyebrow {
  color: #456157;
  font-size: 0.78rem;
  font-weight: 750;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

h1 {
  margin: 12px 0;
  font-family: Georgia, serif;
  font-size: clamp(3rem, 10vw, 6.5rem);
  font-weight: 500;
  letter-spacing: -0.055em;
  line-height: 0.92;
}

.lede {
  max-width: 58ch;
  color: #3d4944;
  font-size: 1.15rem;
  line-height: 1.65;
}

section {
  margin: 48px 0 28px;
  padding: 28px;
  border: 1px solid #c7d2cc;
  border-radius: 18px;
  background: #f8faf7;
  box-shadow: 0 18px 45px rgb(34 53 45 / 8%);
}

h2 {
  margin-top: 0;
  font-size: 1rem;
}

dl {
  margin: 0;
}

dl div {
  display: grid;
  grid-template-columns: minmax(150px, 1fr) 1.4fr;
  gap: 16px;
  padding: 12px 0;
  border-top: 1px solid #dce4df;
}

dt {
  color: #5c6a64;
}

dd {
  margin: 0;
  font-weight: 700;
}

nav {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

a {
  padding: 10px 14px;
  border-radius: 999px;
  color: #f4f7f4;
  background: #203d32;
  text-decoration: none;
}

a:focus-visible,
a:hover {
  outline: 3px solid #7ea995;
  outline-offset: 2px;
}

@media (max-width: 520px) {
  main { padding: 42px 0; }
  dl div { grid-template-columns: 1fr; gap: 4px; }
}
